import type { CustomControlCode } from '@common/enums';
import { nonNullable } from '@common/utils/nonNullableTypeUtils';
import { getRegistryEntry as getCommonRegistryEntry } from '@common/workflow/serviceActivityRegistration';
import type { RegistryEntry } from './customControlRegistry';
import { CustomControlRegistry } from './customControlRegistry';
// The purpose of this module is to register the custom controls without circular dependencies.
// It also provides functions for getting custom controls from the registry after the registrations have been done.
import './register';

export function findRegistryEntry<Data>(code: CustomControlCode, version: number): RegistryEntry<Data> | undefined {
    return CustomControlRegistry.instance.getRegistry().get(code)?.get(version);
}

export function getRegistryEntry<Data>(code: CustomControlCode, version: number): RegistryEntry<Data> {
    const entry = findRegistryEntry<Data>(code, version);
    if (!entry) {
        throw new Error(`No register entry for code: ${code} and version: ${version}`);
    }

    return entry;
}

export function getInitialData<Data extends Record<string, unknown>>(code: CustomControlCode, version: number): Data {
    const commonRegistryEntry = getCommonRegistryEntry<Data>(code, version);

    if (commonRegistryEntry.initialData) {
        return commonRegistryEntry.initialData;
    }

    const { initialData } = getRegistryEntry<Data>(code, version);

    return nonNullable(initialData);
}
